<template>
  <div>
    <Row>
      <Col span="11">
        <FormItem prop=”name”  :label="$t( 'resourceLifecycle.name')">
          <Input v-model="resourceApplicationForm.name" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem label="SKU" prop="sku">
          <RadioGroup v-model="resourceApplicationForm.sku" @on-change="queryAzurePublicIpPrice">
            <Radio v-for="list in skuList" :label="list.sku" :key="list.value">{{list.label}}</Radio>
          </RadioGroup>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem prop=”assign" :label="$t( 'resourceLifecycle.assign' )">
          <RadioGroup v-model="resourceApplicationForm.assign" @on-change="queryAzurePublicIpPrice">
            <Radio v-for="list in assignList" :label="list.assign" :key="list.value">{{list.label}}</Radio>
          </RadioGroup>
        </FormItem>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: 'AmazonElasticAddress',
    props: ['azureResourceApplicationBasicInfoForm', 'cost'],
    components: {},
    data() {
      return {
        resourceGroupList: [],
        skuList: [{
          label: this.$t( 'resourceLifecycle.basics' ),
          value: 'basic',
          sku: 0
        }, {
          label: this.$t( 'resourceLifecycle.standards' ),
          value: 'standard',
          sku: 1
        }],
        assignList: [{
          label: this.$t( 'resourceLifecycle.dynamically' ),
          value: 'dynamic',
          assign: 1
        }, {
          label: this.$t( 'resourceLifecycle.statically' ),
          value: 'static',
          assign: 0
        }],
        resourceApplicationForm: {
          name: '',
          sku: 0,
          assign: 0,
          cost: 0
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t( 'resourceLifecycle.namecannotbeempty' ), trigger: 'blur'}
          ],
          sku: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectSKU' ), trigger: 'change', type: 'number'}
          ],
          assign: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectAssignment' ), trigger: 'change', type: 'number'}
          ]
        }
      }
    },
    mounted: function () {
      this.queryAzurePublicIpPrice()
    },
    methods: {
      //查询价格
      queryAzurePublicIpPrice: function () {
        var submitLifecycleResourceApplicationDTO = {
          "duration": this.azureResourceApplicationBasicInfoForm.periodOfUse,
          "region": this.azureResourceApplicationBasicInfoForm.region,
          "azureEIPRequestDTO": {
            "eipName": this.resourceApplicationForm.name,
            "publicIPSkuType": this.resourceApplicationForm.sku,
            "resourceGroupName": this.azureResourceApplicationBasicInfoForm.resourceGroup,
            "ipAllocationMethod": this.resourceApplicationForm.assign
          }
        }
        this.$api.azurePrice.queryAzurePublicIpPrice(submitLifecycleResourceApplicationDTO)
          .then(res => {
            this.resourceApplicationForm.cost = res.data
            this.$emit('success', this.resourceApplicationForm.cost);
          })
      },
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/azure/elastic_ip/AzureElasticAddress.vue